import { lazy, Suspense } from "react";
import Icon from "@/components/ui/Icon/Icon";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/library/popover";
import NotificationListSkeleton from "./NotificationList/NotificationListSkeleton";
const NotificationList = lazy(() => import("./NotificationList"));

const NotificationManager = () => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="relative inline-flex h-10 w-10 cursor-pointer items-center justify-center rounded-[100px] bg-card-bg p-2">
          <Icon name="ep_bell" className="h-4 w-4" />
        </div>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        side="bottom"
        sideOffset={8}
        className="min-w-60 translate-x-1/2 transform border-none p-0 md:translate-x-0 lg:min-w-80"
      >
        <div className="flex w-full flex-col items-center justify-start gap-8 overflow-hidden rounded-2xl bg-dark-blue py-6">
          <div className="scrollbar max-h-[280px] min-h-[30px] overflow-y-auto overflow-x-hidden">
            <Suspense fallback={<NotificationListSkeleton />}>
              <NotificationList />
            </Suspense>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default NotificationManager;
